import Nav from './Nav';
export default function Thanks(){
  return(
    <main className="registration__main">
      <Nav />
      <h2>Thanks for registering.</h2>
      <h2>Keep an eye on your emails for your invitation to join the group</h2>
    </main>
  )
}